/* BELOUD Gratis-Beanie (16.10.2026): Auswahl in den Warenkorb legen (Eigenschaft _bl_gift),
   bei zu kleinem Warenkorb wieder entfernen, mehr als 1 Geschenk auf 1 reduzieren.
   Gratis macht ihn der Shopify-Rabatt „Gratis-Beanie ab 120 €“. Markup: snippets/free-shipping-meter.liquid */
(function () {
  if (window.__blGiftBound) return;
  window.__blGiftBound = true;
  var busy = false;
  var tries = 0;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }

  // Nach eigener Änderung den Warenkorb neu zeichnen: über die Shopify-Aktion (Drawer morpht selbst),
  // sonst Seite neu laden.
  function refresh() {
    if (onCartPage()) { location.reload(); return Promise.resolve(); }
    var A = window.Shopify && Shopify.actions;
    if (A && typeof A.getCart === 'function' && typeof A.updateCart === 'function') {
      // Eine Zeile mit unveränderter Menge „aktualisieren“: Shopify meldet die Änderung,
      // das Theme zeichnet Drawer und Warenkorb-Zähler neu.
      return Promise.resolve(A.getCart()).then(function (res) {
        var c = (res && res.cart) || res;
        var nodes = c && c.lines && (c.lines.nodes || c.lines);
        if (!nodes || !nodes.length) { location.reload(); return; }
        return A.updateCart({ lines: [{ id: nodes[0].id, quantity: nodes[0].quantity }] });
      }).catch(function () { location.reload(); });
    }
    location.reload();
    return Promise.resolve();
  }

  function addGift(id) {
    var a = window.Shopify && Shopify.actions && Shopify.actions.updateCart;
    if (typeof a === 'function' && !onCartPage()) {
      return Promise.resolve(a({ lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: 1, attributes: [{ key: '_bl_gift', value: '1' }] }] }))
        .then(function (res) { if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message); });
    }
    return post('cart/add.js', { items: [{ id: id, quantity: 1, properties: { _bl_gift: '1' } }] }).then(refresh);
  }

  // Ziel-Mengen je Geschenk-Zeile bestimmen (0 = raus, 1 = behalten)
  function plan(el) {
    var count = parseInt(el.getAttribute('data-bl-gift-count') || '0', 10);
    var eligible = el.getAttribute('data-bl-gift-eligible') === 'true';
    var keys = (el.getAttribute('data-bl-gift-keys') || '').split(',').filter(Boolean);
    if (!eligible && keys.length) return keys.map(function (k) { return { key: k, qty: 0 }; });
    if (eligible && count > 1) return keys.map(function (k, i) { return { key: k, qty: i === 0 ? 1 : 0 }; });
    return [];
  }

  // Über die Shopify-Aktion entfernen (Theme zeichnet Drawer und Zähler selbst neu).
  // Zeilen-IDs der Aktion per Position aus /cart.js zuordnen, Menge zur Sicherheit vergleichen.
  function applyViaActions(jobs) {
    var A = window.Shopify && Shopify.actions;
    if (!A || typeof A.getCart !== 'function' || typeof A.updateCart !== 'function') return Promise.reject(new Error('no actions'));
    return Promise.all([fetch(root + 'cart.js').then(function (r) { return r.json(); }), A.getCart()]).then(function (res) {
      var items = res[0].items || [];
      var c = (res[1] && res[1].cart) || res[1];
      var nodes = c && c.lines && (c.lines.nodes || c.lines);
      if (!nodes || !nodes.length) throw new Error('mismatch');
      var lines = [];
      var used = {};
      jobs.forEach(function (j) {
        var it = items.find(function (x) { return x.key === j.key; });
        if (!it) throw new Error('mismatch');
        var amount = (it.final_line_price / 100).toFixed(2);
        var hits = nodes.filter(function (n) {
          var a = n.cost && n.cost.totalAmount ? parseFloat(n.cost.totalAmount.amount).toFixed(2) : null;
          return !used[n.id] && n.quantity === it.quantity && a === amount;
        });
        if (hits.length !== 1) throw new Error('ambiguous');
        used[hits[0].id] = true;
        lines.push({ id: hits[0].id, quantity: j.qty });
      });
      return A.updateCart({ lines: lines });
    });
  }

  function applyViaAjax(jobs) {
    return jobs.reduce(function (p, j) { return p.then(function () { return post('cart/change.js', { id: j.key, quantity: j.qty }); }); }, Promise.resolve())
      .then(function (cart) {
        // Das Theme stellt den Zähler 10 s lang aus sessionStorage wieder her – vorher korrigieren.
        try { sessionStorage.setItem('cart-count', JSON.stringify({ value: String(cart && cart.item_count != null ? cart.item_count : ''), timestamp: Date.now() })); } catch (e) {}
        location.reload();
      });
  }

  function reconcile() {
    var el = document.querySelector('[data-bl-gift][data-bl-gift-active="true"]');
    if (busy || !el) return;
    var jobs = plan(el);
    if (!jobs.length) { tries = 0; return; }
    if (++tries > 3) return;
    busy = true;
    var run = onCartPage() ? applyViaAjax(jobs) : applyViaActions(jobs).catch(function () { return applyViaAjax(jobs); });
    Promise.resolve(run).catch(function () {}).then(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-bl-gift-variant]') : null;
    if (!btn || busy) return;
    e.preventDefault();
    var id = btn.getAttribute('data-bl-gift-variant');
    if (!id) return;
    busy = true;
    var picker = btn.closest('[data-bl-gift-picker]');
    if (picker) picker.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
    addGift(id).catch(function () { location.reload(); }).then(function () { busy = false; });
  });

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(reconcile, 400); }
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (m.type === 'attributes' && m.target.hasAttribute && m.target.hasAttribute('data-bl-gift')) return schedule();
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType === 1 && (n.hasAttribute('data-bl-gift') || n.querySelector('[data-bl-gift]'))) return schedule();
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-bl-gift-keys', 'data-bl-gift-eligible', 'data-bl-gift-count'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
